module.exports = __webpack_public_path__ + "static/Optiplex7-ed355dd7283a008ec010e842dc7d2208.png";